
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Choice extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public obj;
}
